import { Box, Typography, useTheme } from '@mui/material';
import { FileUploader } from 'react-drag-drop-files';
import { MdOutlineFileUpload } from 'react-icons/md';
import Modal from './Modal';
import Button from './Button';
import NaiveDescription from 'containers/Business/Setting/DataSet/Components/NaiveDescription';
import QaDescription from 'containers/Business/Setting/DataSet/Components/QaDescription';
import ResumeDescription from 'containers/Business/Setting/DataSet/Components/ResumeDescription';
import TableDescription from 'containers/Business/Setting/DataSet/Components/TableDescription';
import BookDescription from 'containers/Business/Setting/DataSet/Components/BookDescription';
import LawDescription from 'containers/Business/Setting/DataSet/Components/LawDescription';
import OneDescription from 'containers/Business/Setting/DataSet/Components/OneDescription';
import ManualDescription from 'containers/Business/Setting/DataSet/Components/ManualDescription';
import PresentationDescription from 'containers/Business/Setting/DataSet/Components/PresentationDescription';
import PaperDescription from 'containers/Business/Setting/DataSet/Components/PaperDescription';

export default function UploadFile({ allowedFileTypes, selectedFiles, handleChange, datasourceType }: any) {
  const theme = useTheme();
  const handleModalOpen = (e: React.MouseEvent, openModal: any) => {
    e.stopPropagation();
    openModal();
  };
  return (
    <Box position='relative'>
      <FileUploader
        multiple={true}
        handleChange={handleChange}
        name='file'
        types={allowedFileTypes ?? fileTypes}
        maxSize={50}
      >
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          border='1.5px dashed #ECECEC'
          padding='24px 16px'
          sx={{ cursor: 'pointer' }}
        >
          <MdOutlineFileUpload style={{ color: theme.palette.primary.main, fontSize: '24px' }} />
          <Typography marginTop={1}>Click to upload or drag and drop</Typography>
          <Box display='flex' alignItems='center' my={1}>
            <Typography color='secondary' textAlign='center' variant='body2' sx={{ wordBreak: 'break-word' }}>
              Only {allowedFileTypes?.join(', ')} files.
            </Typography>
          </Box>
        </Box>
      </FileUploader>
      {datasourceType && (
        <Box position='absolute' bottom={2} left='50%' sx={{ transform: 'translateX(-50%)' }}>
          <Modal
            button={(openModal: any) => (
              <Button
                onClick={(e) => handleModalOpen(e, openModal)}
                size='small'
                variant='text'
                sx={{ zIndex: 1000 }}
                color='primary'
              >
                Read More
              </Button>
            )}
          >
            {datasourceType === 'naive' && <NaiveDescription />}
            {datasourceType === 'qa' && <QaDescription />}
            {datasourceType === 'resume' && <ResumeDescription />}
            {datasourceType === '_table' && <TableDescription />}
            {datasourceType === 'book' && <BookDescription />}
            {datasourceType === 'laws' && <LawDescription />}
            {datasourceType === 'one' && <OneDescription />}
            {datasourceType === 'manual' && <ManualDescription />}
            {datasourceType === 'presentation' && <PresentationDescription />}
            {datasourceType === 'paper' && <PaperDescription />}
          </Modal>
        </Box>
      )}
      <Typography fontSize={13} gutterBottom color='secondary'>
        {selectedFiles && `Number of files selected: ${selectedFiles?.length ?? '0'}`}
      </Typography>
    </Box>
  );
}

const fileTypes = [
  'pdf',
  'txt',
  'htm',
  'html',
  'doc',
  'docx',
  'xlsx',
  'pptx',
  'py',
  'js',
  'java',
  'c',
  'cpp',
  'h',
  'php',
  'go',
  'ts',
  'sh',
  'cs',
  'kt',
  'md',
  'markdown',
  'csv'
];
